module.exports = __webpack_public_path__ + "static/img/kunlun_logo.cb859b1c.png";